
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Fiabilité d’un site Internet : 14 astuces pour rassurer vos visiteurs",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Les visiteurs de votre site Internet vous découvrent-ils ? Cet article vous livre 14 conseils et astuces pour les rassurer, gagner leur confiance et maximiser votre taux de conversion.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Fiabilité d’un site Internet : 14 astuces pour rassurer vos visiteurs",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Les visiteurs de votre site Internet vous découvrent-ils ? Cet article vous livre 14 conseils et astuces pour les rassurer, gagner leur confiance et maximiser votre taux de conversion.",
        },
      ],
    };
  },
};
